const Footer = () => {
    return (
        <footer className="w-full border-t border-gray-200 bg-white">
            <div className="mx-auto max-w-7xl px-4 py-12 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">

                {/* Left */}
                <div className="text-sm text-gray-500">
                    © {new Date().getFullYear()} Weddinfy.
                    <span className="block sm:inline sm:ml-1">
                        Jednostavna organizacija rasporeda sjedenja za svadbenu večeru.
                    </span>
                </div>

                {/* Right */}
                <div className="flex gap-4 text-sm text-gray-500">
                    <a href="/privacy" className="hover:text-gray-800 transition-colors">
                        Privacy Policy
                    </a>
                    <a href="/terms" className="hover:text-gray-800 transition-colors">
                        Terms
                    </a>
                    <a
                        href="/#kontakt"
                        title="weddingherc@gmail.com"
                        className="hover:text-gray-800 transition-colors"
                    >
                        Kontakt
                    </a>
                    {/* <a href="/pricing" className="hover:text-gray-800 transition-colors">
                        Pricing
                    </a> */}
                </div>

            </div>
        </footer>
    );
};

export default Footer;
